import type { SamanDoctorAvailabilityStatus } from '@/common/apis/services/booking/samanDoctorAvailabilityStatus';
import { CENTERS } from '@/common/types/centers';

/** Tomorrow at the doctor's own release clock, or tomorrow 07:45 when the doctor has none announced. */
export const nextReleaseAt = (realReleaseAt?: string | null, now = new Date()) => {
  const at = new Date(now);
  at.setDate(at.getDate() + 1);
  const real = realReleaseAt ? new Date(realReleaseAt) : null;
  // a real clock only when the doctor announced one; a bare date (00:00) or nothing → 07:45
  const hasClock = real && !Number.isNaN(real.getTime()) && (real.getHours() !== 0 || real.getMinutes() !== 0);
  if (hasClock) at.setHours(real.getHours(), real.getMinutes(), 0, 0);
  else at.setHours(7, 45, 0, 0);
  return at.toISOString();
};

/**
 * Saman answer of a doctor whose capacity is full until the next release — what the rollout profile shows
 * to its owner: the red «زمان نوبت دهی پزشک به پایان رسیده است.» card instead of the booking buttons.
 */
export const buildDabbehFullSaman = (centers: Array<{ id: string }>, realReleaseAt?: string | null): SamanDoctorAvailabilityStatus => {
  const releaseAt = nextReleaseAt(realReleaseAt);
  const full = { booking_available: false, nearest_time_slot: null, nearest_available_time: releaseAt };
  const closed = { booking_available: false, nearest_time_slot: null, nearest_available_time: null };
  return {
    in_person_availability: full,
    online_visit_availability: closed,
    centers: (centers ?? []).map(center => ({
      id: String(center.id),
      availability_status: String(center.id) === CENTERS.CONSULT ? closed : full,
    })),
  };
};
